import { i18next, view } from '@yola/ws-sdk';
import constants from '../constants/common';

const { DATA_CREATION_SEQUENCE_ATTRIBUTE } = constants;

function getCompositeItemOptions(compositionGroupNode) {
  const groupElementId = view.accessors.getLiveElementId(compositionGroupNode);
  const options = [{ value: groupElementId, label: i18next.t('Group') }];

  let compositionItem = compositionGroupNode.firstElementChild;

  while (compositionItem) {
    const sequenceAttr = compositionItem.getAttribute(DATA_CREATION_SEQUENCE_ATTRIBUTE);
    const elementId = view.accessors.getLiveElementId(compositionItem.firstElementChild);

    options.unshift({
      value: elementId,
      label: `${i18next.t('Layer')} ${sequenceAttr}`,
    });

    compositionItem = compositionItem.nextElementSibling;
  }

  return options;
}

export default getCompositeItemOptions;
